// extracted by mini-css-extract-plugin
export default {"wrapper":"youtube__wrapper__tBbbw","prompt":"youtube__prompt__f27cp","cta":"youtube__cta__SB2lh","responsiveResize":"youtube__responsiveResize__S12ai"};